import { createFileRoute, useRouter } from '@tanstack/react-router';
import { BuyTable } from '@/components/Pages/Buys/BuyTable';
import { Box, Button } from '@mui/joy';
import { Add as AddIcon } from '@mui/icons-material';

export const Route = createFileRoute('/_protected/buys/')({
  component: BuysPage,
});

function BuysPage() {
  const router = useRouter();

  const handleCreateBuy = () => {
    router.navigate({ to: '/buys/create' });
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
        <Button startDecorator={<AddIcon />} onClick={handleCreateBuy}>
          Crear Compra
        </Button>
      </Box>

      <BuyTable />
    </Box>
  );
}
